import { type UseQueryResult, useQuery } from 'react-query';
import {
  CurrentTenantInfoService,
  Wealthlane_TenantInfoVo,
} from '../../services/wealthlane-customer-services';

const useGetCurrentTenantInfo = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  enabled: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_TenantInfoVo | undefined,
  unknown
> => {
  const currentTenantInfo = useQuery(['getCurrentTenantInfo'], async () => {
    return await handleRequest(CurrentTenantInfoService.getApiCustomerApiTenantCurrent());
  },{
    enabled: enabled
  });

  return currentTenantInfo;
};

export default useGetCurrentTenantInfo;
